import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { registerSparkComponents } from 'genesys-spark';
import { Student } from '../../../lib';
import { interval, Subscription } from 'rxjs';
import { AdmissionUICommonDataService } from '../admission-ui-common-data.service';

@Component({
  selector: 'app-student-info-block',
  templateUrl: './student-info-block.component.html',
  styleUrl: '../admission-ui.component.scss'
})
export class StudentInfoBlockComponent implements OnInit, OnChanges {
  @Input() studentData: Student | undefined;
  @Input() otherInfoMsg: string | undefined;
  @Input() displayOtherInfo: boolean = false;
  @Input() displayPartner: boolean = false;
  @Input() partnerTextColor: string = '';
  @Input() partnerLeadDisplayName: string = '';
  @Input() iDashURL: string = '';
  @Input() studentIdMinTime: number = 0;
  @Input() showStudentId: boolean = true;
  @Input() callDuration: number = 0;
  @Input() isStitchIn: boolean = false;

  studentFinanceMsg: string = '';

  isMilitary: string = 'Yes';

  today: number | undefined;

  timeZoneOffset: number | undefined;

  isLoading: boolean = true;

  partnerTextColorStyle: string = ''

  timeSubscription: Subscription | undefined;
  private timerInterval: any;
  program: string | undefined = '';

  constructor(private readonly commonDataService: AdmissionUICommonDataService) {}

  ngOnInit(): void {
    this.timeZoneOffset = this.studentData?.geolocation?.utcOffset;
    if (this.studentData?.geolocation?.observesDst && this.timeZoneOffset && this.isDaylightSavingTime()) {
      this.timeZoneOffset = this.timeZoneOffset + 1;
    }

    this.updateTime(this.timeZoneOffset);
    registerSparkComponents().then(() => {
      this.isLoading = false;
    });
    
    const programCode = this.studentData?.program?.code?.toUpperCase();
    const CodeReplacementJson = JSON.parse(this.commonDataService.uiConfiguration.find(config => config.key === 'ProgramCodeReplacement')?.value || '{}');
    if(CodeReplacementJson){
      const codeReplacement = CodeReplacementJson[programCode ?? ''];
      this.program = codeReplacement ? codeReplacement : programCode;
    }else{
      this.program = programCode;
    }
  }

  ngOnDestroy() {
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.studentData?.agency == null) {
      this.isMilitary = 'No'
    }
    if (this.studentData?.needsToContactStudentFinance)
      this.studentFinanceMsg = 'Needs to speak to Student Finance.';
    if (this.partnerTextColor !== '') {
      this.partnerTextColorStyle = 'color: ' + this.partnerTextColor;
    }
  }
  
  formatTimeZoneOffset(offset: number | undefined): string {
    if (offset === undefined) {
      return '';
    }
    const hours = Math.floor(Math.abs(offset));
    const minutes = Math.abs(offset % 1) * 60;
    const sign = offset >= 0 ? '+' : '-';
    return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  isDaylightSavingTime(): boolean {
    const now = new Date();
    const jan = new Date(now.getFullYear(), 0, 1);
    const jul = new Date(now.getFullYear(), 6, 1);
    const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return now.getTimezoneOffset() < stdTimezoneOffset;
  }

  updateTime(timeZoneOffset: number | undefined): void {
    this.timeSubscription = interval(1000).subscribe(() => {
      if (timeZoneOffset) {
        const now = new Date();
        const utcTime = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
        this.today = new Date(
          utcTime + timeZoneOffset * 60 * 60 * 1000
        ).getTime();
      } else {
        this.today = Date.now();
      }
    });
  }
}
